import axios from "axios";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { FaArrowDownLong } from "react-icons/fa6";

const ExecutiveProfile = () => {
    const [executiveCode, setExecutiveCode] = useState(null)
    const [executiveDetails, setExecutiveDetails] = useState({})
    useEffect(() => {
        getExecutiveId();
        if (executiveCode) {
            axios.get(`https://api.bakpoket.com/api/BDExecutive/dashboard/${executiveCode}`)
                .then(res => {
                    setExecutiveDetails(res.data)
                    // console.log(res.data)
                    // console.log(executiveDetails)
                })
                .catch(err => console.log(err))
        }
    }, [executiveCode]);

    const getExecutiveId = () => {
        const data = localStorage.getItem('excutiveLogin')
        const parsedate = JSON.parse(data)
        if (parsedate) {
            setExecutiveCode(parsedate.bdeCode)
        }
    }

    return (
        <Container1>
            <CardWrapper className="card border-0">
                <CardBody className="card-body">
                    <div className="d-flex justify-content-center">
                        <div style={{ backgroundColor: 'rgb(201 248 190 / 52%)', width: 'fit-content' }} className="p-2 rounded d-flex flex-column align-items-center">
                            <p className="mb-1">{executiveDetails.loggedInBDECode}</p>
                            <FaArrowDownLong style={{ color: ' #e79d9d' }} />
                        </div>
                    </div>
                    <div className="d-flex justify-content-center flex-wrap gap-3 mt-4">
                        {executiveDetails.referredExecutives?.map((item, index) => (
                            <div key={index}>
                                <div style={{ backgroundColor: 'rgb(201 248 190 / 52%)', width: 'fit-content' }} className="p-2 rounded d-flex flex-column align-items-center">
                                    <p className="mb-1">{item.fullName}</p>
                                    <p className="mb-1">{item.bdeCode}</p>

                                </div>
                            </div>
                        ))
                        }
                    </div>
                </CardBody>

            </CardWrapper>
        </Container1>
    );
};

export default ExecutiveProfile;

/* ================= STYLES ================= */

const Container1 = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  
  width: 100%;
  height: 25rem;
  border-radius: 20px;
  @media(max-width:576px){
    padding: 0px;
  }
`;

const CardWrapper = styled.div`
  max-width: 500px;
  width: 100%;
  height: 100%;
  background-color: #fff;
`;

const CardBody = styled.div`
  height: 100%;
  overflow-y: auto;
  overflow-x: auto;
  padding: 1rem;

  white-space: nowrap;   /* REQUIRED for horizontal scroll */
  &::-webkit-scrollbar {
    width: 8px;   /* vertical scrollbar width */
    height: 8px;  /* horizontal scrollbar height */
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  /* Thumb */
  &::-webkit-scrollbar-thumb {
    background-color: #2a4157; /* scrollbar color */
    border-radius: 4px;
    border: 2px solid #f1f1f1; /* optional spacing around thumb */
  }

  /* Thumb hover */
  &::-webkit-scrollbar-thumb:hover {
    background-color: #2a4157;
  }

  /* Optional: Corner where both scrollbars meet */
  &::-webkit-scrollbar-corner {
    background: #f1f1f1;
  }

  /* ===== Firefox support ===== */
  scrollbar-width: thin;
  scrollbar-color: #2a4157 #f1f1f1;
  .row {
    display: grid;
    grid-template-columns: 1.6fr 0.2fr 2.8fr; /* Label, colon, value */
    padding: 8px 0;
    border-bottom: 1px dotted #ccc;
    font-weight: 500;
    font-size: 0.9rem;
    min-width: 27rem;
  }

  .row:last-child {
    border-bottom: none;
  }

  .label {
    text-align: left;
    padding-right: 10px;
    color: #555;
  }

  .colon {
    text-align: center;
    color: #222;
  }

  .value {
    text-align: left;
    color: #635f5fcf;
    font-weight: 400;
  }
`;



